import React, { useState } from 'react'
import FeatherIcon from 'feather-icons-react'

export function ListaDashboards(props) {

    const [orderByDash, setOrderByDash] = useState('NomeAmigavel')
    const [ascDescDash, setAscDescDash] = useState(0)

    function trataLinkDash(dash) {
        if (dash.opTipoDash === 'CARROSSEL') {
            return `/${dash.Descricao}/${dash.Descricao}/true`
        }
        else {
            return dash.LinkDash ? dash.LinkDash : `/${dash.Descricao}/${dash.NomeAmigavel}/true`
        }
    }

    return (
        <>
            <div className='w-full flex mb-4  items-center mt-4'>
                <input
                    autocomplete="off"
                    value={props.dashFiltro}
                    placeholder='Filtrar pelo Nome da Publicação'
                    onChange={event => props.setDashfiltro(event.target.value)}
                    id='dashFiltro'
                    className='w-full uppercase text-sm p-1 rounded-md shadow-lg focus:outline-none focus:border-primaryColor focus:ring-1 focus:ring-primaryColor'
                />
            </div>

            <div className={`${props.Altura} overflow-scroll`} >
                <table className='w-full'>
                    <thead className='sticky top-0'>
                        <tr className='bg-primaryColor text-sm text-white-100 text-left uppercase whitespace-nowrap '>
                            <th className={`py-1 px-1 text-center ${props.showEditButtom ? 'w-[8.5rem]' : 'w-[4.25rem]'} `}>Opções</th>
                            <th onClick={() => {
                                setOrderByDash('Id')
                                setAscDescDash(ascDescDash === 0 ? 1 : 0)
                            }} className='py-1 px-1 text-center cursor-pointer select-none'>Id</th>
                            <th onClick={() => {
                                setOrderByDash('NomeAmigavel')
                                setAscDescDash(ascDescDash === 0 ? 1 : 0)
                            }} className='py-1 px-1 text-left cursor-pointer select-none'>Nome Amigável</th>
                            <th onClick={() => {
                                setOrderByDash('Descricao')
                                setAscDescDash(ascDescDash === 0 ? 1 : 0)
                            }} className='py-1 px-1 text-left cursor-pointer select-none'>Nome Interno</th>
                            <th onClick={() => {
                                setOrderByDash('Departamento')
                                setAscDescDash(ascDescDash === 0 ? 1 : 0)
                            }} className='py-1 px-1 text-left cursor-pointer select-none'>Categoria</th>
                            <th onClick={() => {
                                setOrderByDash('opTipoDash')
                                setAscDescDash(ascDescDash === 0 ? 1 : 0)
                            }} className='py-1 px-1 text-left cursor-pointer select-none'>Tipo</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.dashboards.length > 0 ? (
                            props.dashboards
                                .sort((a, b) =>
                                    a[orderByDash] > b[orderByDash]
                                        ? ascDescDash === 0
                                            ? 1
                                            : -1
                                        : ascDescDash === 0
                                            ? -1
                                            : 1
                                )
                                .map((dash, key) => (
                                    <tr key={key} className='odd:bg-white-100 even:bg-lightgray  whitespace-nowrap text-sm hover:bg-gray-300 '>
                                        <td className='!bg-white-200'>
                                            <div className='flex flex-row gap-[0.3rem]'>
                                                {
                                                    props.showEditButtom === true ?
                                                        <>
                                                            <button className='hover:bg-primaryColor p-2 text-primaryColor font-semibold hover:text-white-100 border border-primaryColor rounded'
                                                                onClick={() => props.encheCamposTela(key)}>
                                                                <FeatherIcon icon="edit" size={15} />
                                                            </button>

                                                            <button className='hover:bg-red-500 text-red-500 p-2 font-semibold hover:text-white-100 border border-red-500 rounded'
                                                                onClick={() => props.excluiDashBoard(key)}>
                                                                <FeatherIcon icon="trash" size={15} />
                                                            </button>
                                                        </>
                                                        :
                                                        null
                                                }

                                                <button className='hover:bg-primaryColorFocus p-2 text-white-200 font-semibold border bg-blueInn-100 border-primaryColor rounded'
                                                    onClick={() => props.handleRenderLinkDash(dash)}
                                                >
                                                    <FeatherIcon icon="eye" size={15} />
                                                </button>

                                                <a
                                                    className='hover:bg-primaryColor p-2 text-primaryColor font-semibold hover:text-white-100 border border-primaryColor rounded'
                                                    onClick={() => props.handleNewTab(dash)}
                                                    href={trataLinkDash(dash)}
                                                    rel="noreferrer"
                                                    target="_blank"
                                                >
                                                    <FeatherIcon icon="external-link" size={15} />
                                                </a>
                                            </div>
                                        </td>
                                        <td className='text-center'>{dash.Id}</td>
                                        <td className='uppercase'>{dash.NomeAmigavel}</td>
                                        <td>{dash.Descricao}</td>
                                        <td className='uppercase' >{dash.Departamento}</td>
                                        <td className='uppercase' >{dash.opTipoDash}</td>
                                    </tr>
                                ))
                        ) : (
                            <tr className='bg-white-100 w-full'>
                                <td className='text-center italic text-sm' colSpan="6">Nenhum registro encontrado</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>

    )
}
